/**
 * Account Aggregator Token Drawer
 *
 * Shows generated token with copy helper.
 */

import React from 'react';
import { Drawer, DrawerContent, DrawerHeader, DrawerOverlay, Button } from 'equal-ds-ui';
import { Copy } from 'lucide-react';
import type { AccountAggregatorTokenDrawerProps } from '../../../types/account-aggregator';

export const AccountAggregatorTokenDrawer: React.FC<AccountAggregatorTokenDrawerProps> = ({
  isOpen,
  token,
  aggregatorId,
  onClose,
}) => {
  if (!isOpen || !token) {
    return null;
  }

  const handleCopy = () => {
    void navigator.clipboard?.writeText(token);
  };

  return (
    <>
      <DrawerOverlay />
      <Drawer variant="overlay" width="420px" topOffset="var(--react-shell-header-height)">
        <DrawerHeader className="border-b border-border-default pb-4" onClose={onClose}>
          <div>
            <h2 className="text-xl font-semibold text-text-primary">
              Token generated for {aggregatorId}
            </h2>
            <p className="text-sm text-text-secondary mt-1">
              Copy and store the token securely. It will not be shown again.
            </p>
          </div>
        </DrawerHeader>
        <DrawerContent className="p-6 space-y-4">
          <div className="bg-background-secondary border border-border-default rounded-lg px-4 py-3 break-words text-sm font-mono">
            {token}
          </div>
          <Button variant="secondary" size="sm" onClick={handleCopy}>
            <Copy className="w-4 h-4 mr-2" />
            Copy token
          </Button>
        </DrawerContent>
      </Drawer>
    </>
  );
};
